import { authRoles } from 'app/auth';
import i18next from 'i18next';
import UserGroupEditForm from './editform/UserGroupEditForm';
import UserGroupTable from './table/UserGroupTable';
import en from './i18n/en';
import hu from './i18n/hu';

i18next.addResourceBundle('en', 'userGroup', en);
i18next.addResourceBundle('hu', 'userGroup', hu);

export default [
	{
		path: '/user-group/edit/:id/:tabKey?',
		component: UserGroupEditForm,
		auth: authRoles.userGroup
	},
	{
		path: '/user-group/:sessionNameParam?',
		component: UserGroupTable,
		auth: authRoles.userGroup
	}
];
